/**
 * 工作室小游戏交叉推广按钮
 */
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")

const W = 100 * 1.4
const H = 128 * 1.4
const GAP = 20
var PromoteButtton = xClass("PromoteButtton", cc.Node)
PromoteButtton.create = function (promotCfg) {
    var instance = PromoteButtton.new()
    assert(instance)
    if (instance) {
        instance.init(promotCfg)
    }
    return instance
}
PromoteButtton.prototype.init = function (promotCfg) {
    let self = this
    this.pfManager = PromoteFlowManager.getInstance();

    self.icon = cc.Sprite.create()
    self.addChild(self.icon)
    //self.icon.setScake
    self.setContentSize(W + GAP, H)
    // 低清
    // if (_G.__use_low_effect){
    //     scale = 0.62;
    //     self.setScale(scale)
    // }

    let btn = UIButton.create(self, true)
    ButtonPushBounceAnim.create(btn)
    btn.on(UIButtonEvent.Click, function (evt) {
        self.onCick(evt)
    })
    self.icon.setPosition(GAP, 0);
    self.refresh()
}

PromoteButtton.prototype.refresh = function () {
    let self = this


    let promoteCfg = this.pfManager.getShowConf();
    self.curPromoteCfg = promoteCfg;
    
    let currentScene = cc.director._runningScene && cc.director._runningScene.name;
    if (currentScene == "HomeScene"){
        // cc.log("PromoteButtton refresh", promoteCfg);
        let nextImg = promoteCfg["imageUrl"];

        function resizeIcon(icon) {
            // 计算图标显示比例
            let size = icon.getContentSize()
            let height = size.height
            let width = size.width
            let maxHeight = H
            let maxWidth = W
            let scale
            if (height > width) {
                scale = maxHeight / height
            } else {
                scale = maxWidth / width
            }
            icon.setScale(scale)
            self.pfManager.dcShow();
            // if (self.needDCShow){
            //     DCAssist.dc4ClickIcon("promotion", "show", {"textId":self.curPromoteCfg["promotion_id"]})
            // }
        }

        function onLoad(url) {
            var oldIcon = self.icon;
            var removeOldIcon = function(){
                oldIcon.removeFromParent(true);
            }
            oldIcon.runAction(cc.sequence(cc.fadeOut(0.25), cc.callFunc(removeOldIcon)));
            var newIcon = cc.Sprite.create();
            self.addChild(newIcon);
            newIcon.initWithFile(url);
            newIcon.setOpacity(0);
            newIcon.runAction(cc.fadeIn(0.25));     
            newIcon.setPosition(oldIcon.x, oldIcon.y);
            resizeIcon(newIcon);
            self.icon = newIcon;
        }

        if (cc.spriteFrameCache.getSpriteFrame(nextImg)) {
            onLoad(nextImg)
        } else {
            function onFail() {
                cc.log("promote icon load image fail")
            }
            preloadWithLoading(nextImg, function () {
                var texturePath = cc.path.changeBasename(nextImg, ".png");
                texture = cc.textureCache.addImage(texturePath);
                var size = texture._contentSize;
                var frame = new cc.SpriteFrame(texture, cc.rect(0, 0,  size.width, size.height), false, cc.p(0, 0), size);
                cc.spriteFrameCache.addSpriteFrame(frame, nextImg);
                onLoad(nextImg)
            }, onFail, onFail, false)
        }
    }

    if (Object.keys(self.pfManager.promoteConfigs).length > 1){
        var changeTime = promoteCfg.promotion_changing_time;
        self.changeTask = setTimeout(handler(self, self.refresh), changeTime);
    }
}

PromoteButtton.prototype.onCick = function () {
    var self = this
    cc.log("PromoteButtton onCick", self.busy)
    // const path1 = self.pfManager.getPath(self.curPromoteCfg);
    if (self.busy) return;
    const promoteId = self.curPromoteCfg["promotion_id"]
    self.busy = true;
    if (isWechatGameEnv()) {
        DCAssist.dc4ClickIcon("promotion", "click", {"textId":promoteId})
        const appid = self.curPromoteCfg["gameAppId"];
        // const path = self.curPromoteCfg["path"] || "";
        const path = self.pfManager.getPath(self.curPromoteCfg);

        const extraData = self.curPromoteCfg["launchOption"] ? JSON.parse(self.curPromoteCfg["launchOption"]) : {}
        if (window.mini && mini.supportNavigateOut()) {
            mini.navigateToMiniProgram({
                appId: appid,
                path: path,
                extraData: extraData,
                success: function success() {
                    console.log('游戏跳转成功，appid: ' + appid);
                    DCAssist.dc4ClickIcon("promotion", "success", {"textId":promoteId})
                },
                fail: function fail() {
                    console.warn('游戏跳转失败，appid：', appid, '请检查是否和目标跳转小游戏绑定在同一个公众号，或者是当前项目是否使用了正确的小游戏appid。');
                },
                complete: function complete() {
                    setTimeout(function () {
                        self.busy = false;
                    }, 200); // 限制点击频率
                }
            });
        } else {
            console.warn('当前小游戏基础库版本不支持跳转功能，基础库要求在2.2.0以上，请参照文档 http://open.qqgame.qq.com/mobile/wiki/215/219/219.html 查看兼容相关处理');
        }
    }
    return
}
module.exports = PromoteButtton